import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const DashboardRoutes = [
    {
        path: '/dashboard',
        component: () => import('../components/general/RootModule.vue'),
        meta: {
            title: 'DashboardModule.title',
            icon: 'mdi-view-dashboard-outline',
            auth: {
                required: true,
            },
            showInMenu: true,
            moduleRoot: true,
        },
        children: [
            {
                path: '',
                name: RouteNamesEnum.Dashboard,
                component: () => import('../views/dashboard-module/DashboardView.vue'),
                meta: {
                    title: 'DashboardModule.title',
                    auth: {
                        required: true,
                    },
                    showInMenu: true,
                },
            },
        ],
    },
];

export default DashboardRoutes;
